@if (!useSummaryView) {
  @if (!field.hidden) {
    <div class="flex flex-col w-full" animate.enter="fade-in">
      <div class="flex flex-row items-center w-full">
        @if (field.browserOpts.inLineWithCaption) {
          <mat-label class="mr-2 mb-4 font-medium">
            {{ field.label | localize }}
          </mat-label>
        }
        <mat-form-field class="w-full">
          @if (!field.browserOpts.inLineWithCaption) {
            <mat-label>{{ field.label | localize }}</mat-label>
          }
          <input matInput [formControl]="field.control" [placeholder]="field.placeholder | localize"
            [matAutocomplete]="auto" [readonly]="field.readonly" [required]="field.required" />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayValue">
              @for (opt of filteredOptions | async; track opt) {
                <mat-option [value]="opt.code">
                  {{ opt.value | localize }}
                </mat-option>
              }
            </mat-autocomplete>
            @if (field.hint) {
              <mat-hint>{{ field.hint | localize }}</mat-hint>
            }
            @if (!field.readonly && field.control.errors) {
              <mat-error>
                @if (field.control.hasError('required')) {
                  {{ 'errorRequiredField' | transloco }}
                }
                @if (field.control.hasError('maxlength')) {
                  {{ 'errorMaxLengthField' | transloco:{ requiredLength: field.control.errors.maxlength.requiredLength } }}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }
  } @else {
    {{ displayedValue }}
  }
